<div class="filter">
  <div class="filter__sum">
    <div class="filter__sum__item">
      <sb-icon icon="location"></sb-icon>
      {{playerAggregationData?.locations | sbNumberFormat}}
    </div>
    /
    <div class="filter__sum__item">
      <sb-icon icon="playerOnline"></sb-icon>
      {{playerAggregationData?.devices | sbNumberFormat}}
    </div>
  </div>
</div>
